import { useEffect, useRef } from 'react'
import { useSprig } from '@mc/sprig'
import { useUser } from '../contexts/AuthContext'

export const SprigUserIdentify = () => {
  const { identify, isConfigured } = useSprig()
  const { user, isLoading } = useUser()
  const userId = user?.analytics?.userId
  const email = user?.email
  const lastIdentifiedRef = useRef<string | null>(null)

  useEffect(() => {
    if (!isConfigured || isLoading || !userId) return
    if (lastIdentifiedRef.current === userId) return
    lastIdentifiedRef.current = userId
    identify({
      userId,
      ...(email ? { attributes: { email } } : {}),
    })
  }, [identify, isConfigured, isLoading, userId, email])

  return null
}
